type ScreenshotMatch = { matched: false } | { matched: true; combo: string };

const DIGIT_BY_CODE: Record<string, '3' | '4' | '5'> = {
  Digit3: '3',
  Digit4: '4',
  Digit5: '5',
};

const DIGIT_BY_KEY: Record<string, '3' | '4' | '5'> = {
  '3': '3',
  '4': '4',
  '5': '5',
  '#': '3',
  $: '4',
  '%': '5',
};

export function isScreenshotShortcut(event: KeyboardEvent): ScreenshotMatch {
  const isPrintScreen =
    event.key === 'PrintScreen' || event.code === 'PrintScreen';

  if (isPrintScreen) return { matched: true, combo: 'PrintScreen' };

  const isMacShot = event.metaKey && event.shiftKey;
  const macShotDigit = DIGIT_BY_CODE[event.code] ?? DIGIT_BY_KEY[event.key];

  if (isMacShot && macShotDigit) {
    return { matched: true, combo: `Meta+Shift+${macShotDigit}` };
  }

  return { matched: false };
}
